module.exports = __webpack_public_path__ + "static/media/Mar_2026_2.ff051c9f.webp";